import { IGameCharacter } from '../../../../../../../api/types/character'
import React from 'react'
import { Chip, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(0.2),
    },
  })
)

interface NpcCharBadgeProps {
  game_char: IGameCharacter
  isSelected: boolean
  handleDelete: () => void
  handleClick: () => void
}

export const NpcCharBadge: React.FC<NpcCharBadgeProps> = ({
  game_char,
  handleDelete,
  handleClick,
  isSelected,
}) => {
  const classes = useStyles()
  return (
    <>
      <Chip
        className={classes.root}
        label={game_char.character.name}
        variant={isSelected ? 'filled' : 'outlined'}
        onDelete={handleDelete}
        onClick={handleClick}
      />
    </>
  )
}
